var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 22,
    fill: "none",
    stroke: "#213867",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.063 3.781H3.938a1.97 1.97 0 0 0-1.97 1.969v11.813c0 1.087.882 1.968 1.97 1.968h13.125a1.97 1.97 0 0 0 1.968-1.968V5.75a1.97 1.97 0 0 0-1.968-1.969"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 2.469V3.78m10.5-1.312V3.78m3.281 3.282H1.97m10.5 4.101 1.78-1.312h.188v6.89m-8.121-6.278c.177-.3.674-.777 1.552-.777 1.038 0 1.964.566 1.964 1.637a1.56 1.56 0 0 1-.456 1.118c-.449.46-1.133.635-1.506.635.422 0 1.197.198 1.704.717.325.33.475.797.475 1.315 0 1.144-.965 1.797-2.138 1.797-.991 0-1.6-.72-1.8-1.06"
  })));
};
export default SvgCalendar;